// Shared guard so ChatBody.jsx (fires on unread-count change) and
// socketMessageDispatcher.js (fires on a new incoming socket message while
// the chat is active) can't both dispatch markMessageAsRead for the same
// contact within the same short window -- each has its own debounce, but
// nothing previously stopped both debounces from resolving independently.
const recentDispatches = new Map(); // contactId -> timestamp of last claim

const DEDUPE_WINDOW_MS = 1200;

/**
 * Returns true if the caller may proceed to dispatch markMessageAsRead for
 * this contact, and records the claim. Returns false if another caller
 * already claimed this contact within the window.
 */
export const claimMarkAsReadDispatch = (contactId, windowMs = DEDUPE_WINDOW_MS) => {
  const key = String(contactId);
  const now = Date.now();
  const last = recentDispatches.get(key);
  if (last && now - last < windowMs) {
    return false;
  }
  recentDispatches.set(key, now);
  return true;
};
